const DshSensors = () => import('@/components/sensors/Dashboard')
const DshCul = () => import('@/components/dashboards/Cultivation')
const DshPlants = () => import('@/components/dashboards/Plants')
const DshHarvests = () => import('@/components/dashboards/Harvests')
const DshComp = () => import('@/components/dashboards/Compliance')
export default function buildMenu (allowed) {
  var routes = []
  if (allowed == null || allowed.includes('Dashboards'))  {
    routes =  [
      {
        name: 'DshCultivation', 
        path: '/DshCultivation', 
        component: DshCul
      },
      {
        name: 'DshHarvests', 
        path: '/DshHarvests', 
        component: DshHarvests
      },
      {
        name: 'DshCompliance', 
        path: '/DshCompliance', 
        component: DshComp
      },
      {
        name: 'DshPlants', 
        path: '/DshPlants', 
        component: DshPlants
      }
  ] } 
  if (allowed == null || allowed.includes('Sensors') || allowed.includes('Automation') || allowed.includes('Sidekick'))  {
    routes.push (
      {
        name: 'DshSensors', 
        path: '/DshSensors', 
        component: DshSensors
      }
    )
  }
  return routes
}
